import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { DropdownOptionModel } from '../../../benefit/models/Common';
import { config } from '../../config';

import {
  EditAccountReadModel,
  MerchantAccountListModel,
  SendInvitationCommand,
  UpdateAccountCommand,
  UpdatePasswordCommand,
  UpdatePersonalAccountCommand,
} from '../../models/accounts';
import { IAccountInfoContext } from '../../contexts/common';

interface IMerchantAccountsService {
  getWhoAmI: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<IAccountInfoContext>>;
  getAccounts: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<MerchantAccountListModel[]>>;
  sendInvitation: (
    data: SendInvitationCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  getAccountRoles: (
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<DropdownOptionModel[]>>;
  updateAccount: (
    data: UpdateAccountCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  updatePersonalAccount: (
    data: UpdatePersonalAccountCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  getEditAccountReadModel: (
    accountId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<EditAccountReadModel>>;
  updatePassword: (
    data: UpdatePasswordCommand,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  inactivateAccount: (
    accountId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
}

export const merchantAccountsService: IMerchantAccountsService = {
  getWhoAmI(axiosConfig) {
    return ajax.get<IAccountInfoContext>(
      `${config.merchantsApiUrl}/who-am-i`,
      axiosConfig,
    );
  },
  getAccounts(queryString, axiosConfig) {
    return ajax.get<MerchantAccountListModel[]>(
      `${config.merchantsApiUrl}/odata/accounts?${queryString}`,
      axiosConfig,
    );
  },
  sendInvitation(data, axiosConfig) {
    return ajax.post<boolean>(
      `${config.merchantsApiUrl}/accounts/invite`,
      data,
      axiosConfig,
    );
  },
  getAccountRoles(axiosConfig) {
    return ajax.get<DropdownOptionModel[]>(
      `${config.merchantsApiUrl}/accounts/roles`,
      axiosConfig,
    );
  },
  updateAccount(data, axiosConfig) {
    return ajax.put<boolean>(
      `${config.merchantsApiUrl}/accounts/${data.accountId}`,
      data,
      axiosConfig,
    );
  },
  updatePersonalAccount(data, axiosConfig) {
    return ajax.put<boolean>(
      `${config.merchantsApiUrl}/accounts/personal`,
      data,
      axiosConfig,
    );
  },
  getEditAccountReadModel(accountId, axiosConfig) {
    return ajax.get<EditAccountReadModel>(
      `${config.merchantsApiUrl}/accounts/${accountId}`,
      axiosConfig,
    );
  },
  updatePassword(data, axiosConfig) {
    return ajax.put<boolean>(
      `${config.merchantsApiUrl}/accounts/password`,
      data,
      axiosConfig,
    );
  },
  inactivateAccount(accountId, axiosConfig) {
    return ajax.delete<boolean>(
      `${config.merchantsApiUrl}/accounts/${accountId}`,
      axiosConfig,
    );
  },
};
